import { documentTypeOptions } from 'app/constants/document-types';

import { AlertsState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const alertsState: AlertsState = {
  alert: null,
  alerts: [],
  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,
  formState: {
    name: '',
    emails: '',
    sms: '',
    // Alert time window range
    isToggleAlertTimeWindowRange: false, // Checkbox
    alertTimeWindowFromTime: null,
    alertTimeWindowUntilTime: null,
    // Driver selection
    drivers: [],
    // Terminal selection
    terminals: [],
    // Available alerts - Violation Warning Thresholds selection
    isToggleViolationWarning: false, // Checkbox
    shiftViolationWarningThreshold: { value: 'PT0S', label: '0 Minute' },
    drivingViolationWarningThreshold: { value: 'PT0S', label: '0 Minute' },
    cycleViolationWarningThreshold: { value: 'PT0S', label: '0 Minute' },
    breakViolationWarningThreshold: { value: 'PT0S', label: '0 Minute' },
    nextViolationWarningThreshold: { value: 'PT0S', label: '0 Minute' },
    // Available alerts checkboxes
    isViolationNotification: false,
    isPendingEditRequestChanged: false,
    isPreTripDvir: false,
    isPostTripDvir: false,
    isDvirFailure: false,
    isDvirDefects: false,
    isOdometerJump: false,
    isSpecialMoves: false,
    isMalfunction: false,
    isDocumentSaved: false,
    documentTypes: documentTypeOptions,
    // Unidentified driving notification
    isUnidentifiedDrivingMode: false,
    // Alert type assignee
    assignBy: 'TERMINALS',
  },
  isToggleDeleteAlertModal: false,
  editModal: false,
  createModal: false,
};
